<template>
  <span
    v-if="$store.state.slide.hasTimeLimit &&
      !$store.state.presentation.audiencePacing &&
      $store.state.presentation.presenting"
    v-show="!$store.state.slide.stopSubmission"
    ref="timeToAnswer"
  />
</template>

<script>
import Config from '@/config'
import Util from '@/util'

export default {
  data() {
    return {
      timeToAnswer: 0,
      requestFrame: null,
    }
  },

  watch: {
    '$store.state.slide.stopSubmission': function (stop) {
      this.cancelAnimationFrame()
      if (!stop) {
        this.startCountDownTimeToAnswer()
      }
    },
    '$store.state.slide.stopSubmissionTime': function () {
      this.cancelAnimationFrame()
      this.startCountDownTimeToAnswer()
    },
  },

  mounted() {
    if (!this.$store.state.offsetTime) {
      this.$http.get(Config.api.getTimestamp).then((res) => {
        this.$store.state.offsetTime = new Date().getTime() - res.body.timeStamp
        if (!this.$store.state.slide.stopSubmission) {
          this.startCountDownTimeToAnswer()
        }
      }).catch(() => {
        this.$store.state.offsetTime = 0
        if (!this.$store.state.slide.stopSubmission) {
          this.startCountDownTimeToAnswer()
        }
      })
    } else if (!this.$store.state.slide.stopSubmission) {
      this.startCountDownTimeToAnswer()
    }
  },

  destroyed() {
    this.cancelAnimationFrame()
  },

  methods: {
    startCountDownTimeToAnswer() {
      const self = this
      const endTime = this.$store.state.slide.stopSubmissionTime
      const { offsetTime } = self.$store.state

      if (!endTime) return
      this.timeToAnswer = parseInt((endTime - (new Date().getTime() - offsetTime)) / 1000, 10)

      let contextTimeToAnswer = this.$refs.timeToAnswer
      if (contextTimeToAnswer) {
        contextTimeToAnswer.textContent = `(${Util.timeToString(this.timeToAnswer)})`
      }

      let secondTime = 0

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime !== timeRun) {
          secondTime = timeRun

          self.timeToAnswer = parseInt((endTime - (new Date().getTime() - offsetTime)) / 1000, 10)
          contextTimeToAnswer = self.$refs.timeToAnswer

          if (contextTimeToAnswer) {
            contextTimeToAnswer.textContent = `(${Util.timeToString(self.timeToAnswer)})`
          }
        }

        if (self.timeToAnswer > 0) {
          self.requestFrame = window.requestAnimationFrame(step)
        } else {
          self.cancelAnimationFrame()
        }
      }

      self.requestFrame = window.requestAnimationFrame(step)
    },

    cancelAnimationFrame() {
      if (this.requestFrame) {
        window.cancelAnimationFrame(this.requestFrame)
      }
    },
  },
}
</script>
